"use client";

import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";

function ProjectsPageHeader(): ReactElement {
  const t = useTranslations("projects.Page");
  return (
    <header className="relative min-h-32 py-4 flex flex-row items-end border-b bg-accent overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto flex-1 flex flex-col gap-2 justify-between px-4 animate__animated animate__slideInUp animate__faster">
        <h1 className="text-2xl md:text-3xl font-semibold">{t("title")}</h1>
        <p className="text-sm leading-tight opacity-75">{t("description")}</p>
      </div>
    </header>
  );
}

export { ProjectsPageHeader };
